import { ProfileInfo } from '@deltek/specification-client/core/Models/profileInfo'
import { ElementType } from 'api/graphQL/reactiveVars/element'

export interface TrackedChange {
    id: string
    changeType: TrackChangeType
    status: TrackChangeStatus
    changeDateTime: string
    changedText: string
    userProfileInfo: Partial<ProfileInfo>
    elementId: string
    elementType: ElementType
    contentItemId: string
    contentItemElementId: string
    rootContentItemId: string
    partType: string
    familyId: string
    trackChangeComments: Comment[]
    trackChangeTypeToChangedTexts: TrackedChangeTexts[]
    isSharedContentItem: boolean
    acceptedRejectedProfileInfo: Partial<ProfileInfo>
    approvedOrRejectedDateTime: string
    isHidden?: boolean
}
export interface TrackedChangeTexts {
    authoredUserId: string
    changedText: string
    contentItemElementId: string
    trackChangeType: string
}

export interface Comment {
    id: string
    trackChangeId: string
    userId: string
    createdDate: string
    updatedDate: string
    comment: string
    userProfileInfo: Partial<ProfileInfo>
}

export enum TrackChangeType {
    ADDED = 'ADDED',
    MODIFIED = 'MODIFIED',
    DELETED = 'DELETED',
    REPLACED = 'REPLACED',
    ACCEPTED = 'ACCEPTED',
    DISABLED = 'DISABLED',
    OPTIONGROUP = 'OPTIONGROUP',
}

export enum TrackChangeStatus {
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
    OPTIONGROUP = 'OPTIONGROUP',
}

export enum TrackChangeStatusMap {
    OptedIn = 'Modified',
    OptedOut = 'ResetOption',
    InActive = 'Disabled',
}
export interface GetTrackChanges {
    trackChanges: TrackedChange[]
}

export interface CreateTrackChangeCommentInput {
    comment: string
    elementId: string
    projectId: string
    trackChangeId: string
    familyId: string
}

export interface DeleteTrackChangeCommentInput {
    id: string
    projectId: string
    trackChangeId: string
}

export interface UpdateTrackChangeCommentInput {
    id: string
    projectId: string
    comment: string
    trackChangeId: string
}

export interface AcceptTrackChangeInput {
    trackChangeId: string
}

export interface RejectTrackChangeInput {
    trackChangeId: string
}
